/** Portal select menus above sticky DataTable headers (z-index 2–6). */
export const DOCK_SELECT_MENU_PORTAL = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : undefined,
  menuPosition: "fixed" as const,
  styles: {
    menuPortal: (base: Record<string, unknown>) => ({ ...base, zIndex: 1100 }),
  },
};
